import dynamic from "next/dynamic";
import QueryString from "qs";
import { GetServerSideProps, NextPage } from "next";
const UseCasePage = dynamic(() => import("@/Components/pages/UseCasePage"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL as string;

interface UseCaseDetailProps {
  apiResData: any; // You can replace `any` with a stricter type from your Strapi schema
  slug: string;
  isNew: boolean;
}

export const getServerSideProps: GetServerSideProps<
  UseCaseDetailProps
> = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const slug = ctx.params?.slug as string;

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      publicationState: "preview",
      filters: {
        slug: {
          $eq: slug,
        },
        publishedAt: {
          $null: true,
        },
      },
      populate: "deep, 6",
    },
    {
      encodeValuesOnly: false,
    },
  );
  apiRes = await fetch(`${baseUrl}use-cases?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();
  isNew = apiResData.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      isNew,
    },
  };
};

const UseCaseDetail: NextPage<UseCaseDetailProps> = ({ apiResData, slug }) => {
  return (
    <div id="root">
      <div className="middle-sction middle-pad">
        <UseCasePage slug={slug} data={apiResData} />
      </div>
    </div>
  );
};

export default UseCaseDetail;
